import React, { useEffect, useContext } from 'react';
import { useParams } from 'react-router';
import { Form, Col, Row, Alert } from 'react-bootstrap';
import AppContext from 'Utils/AppContext';
import { enginePorts } from 'Utils';
import ProdToggle from './ProdToggle';
const MongoSourceEditor = ({ connection, setConnection }) => {
  const { rulesList } = useContext(AppContext);
  const { id } = useParams();

  const defaultRules = rulesList.find(rules => rules.default === true);

  const defaults = {
    database: '',
    host: '',
    name: '',
    password: '',
    port: '',
    user: '',
    type: 'mongodb',
    protocol: 'mongodb+srv://',
    peering: false,
    ...!id && ({
      scheduleEnabled: true,
      scheduleDayOfWeek: 'SAT',
      scheduleWeekOccurrence: 1,
      scheduleHour: 0,
      scheduleMinute: 0,
      scheduleRules: defaultRules
    })
  }

  // Merge defaults UNDER any fields already populated by the parent SourceForm dropdown
  // (type / customDatabaseType) or a `?prefill=` payload (pipeline board Connect → host/
  // port/name). A plain `setConnection(defaults)` would wipe those out — same pattern as
  // DbSourceEditor / SnowflakeSourceEditor.
  useEffect(() => { if (!id) setConnection((prev) => ({ ...defaults, ...(prev || {}) })); }, []);

  return (
    <div className='text-left'>
      <Row className='mb-4'>
        <Col lg='12'>
          <Form.Label>Data source name *</Form.Label>
          <Form.Control
            size='sm'
            placeholder='Sample_Mongodb'
            value={connection.name}
            onChange={(n) => setConnection({ ...connection, name: n.target.value })}
            type='text'
            required
            isInvalid={connection && connection.name && connection.name.includes(' ')}
          />
          <Form.Control.Feedback type="invalid">
            Data source names must not include spaces.
          </Form.Control.Feedback>
        </Col>
      </Row>
      <ProdToggle />
      <Row className='mb-4'>
        <Col className='pr-0' lg='4'>
          <Form.Label>Protocol</Form.Label>
          <Form.Control
            size='sm'
            as='select'
            value={connection.protocol}
            onChange={(n) => { 
              setConnection({ ...connection, protocol: n.target.value, port: enginePorts['mongodb'] });
            }}
          >
            <option value='mongodb+srv://'>mongodb+srv://</option>
            <option value='mongodb://'>mongodb://</option>
          </Form.Control>
        </Col>
        <Col className='pl-1' lg='8'>
          <Form.Label>Host URL *</Form.Label>
          <Form.Control
            size='sm'
            placeholder='mongodb.okupu.mongodb.net'
            value={connection.host}
            onChange={(n) => setConnection({ ...connection, host: n.target.value })}
            type='text'
            required
          />
        </Col>
      </Row>
      { connection.protocol === 'mongodb+srv://' && (
        <Row>
          <Col>
            <Alert key='info' variant='info'>
            This 'mongodb+srv://' protocol supports the MongoDB Atlas API. Please use the 'mongodb://' protocol for other MongoDB deployments.
          </Alert>
            </Col>
          </Row>
      )}
      <Row className='mb-4'>
        <Col className='pr-1'>
          <Form.Label>Port *</Form.Label>
          <Form.Control
            size='sm'
            value={connection.port}
            placeholder='27017'
            onChange={(n) => setConnection({ ...connection, port: n.target.value })}
            type='number'
            required
            disabled={connection.protocol === 'mongodb+srv://'}
          />
        </Col>
        <Col className='pl-1'>
          <Form.Label>Database *</Form.Label>
          <Form.Control 
            size='sm'
            value={connection.database}
            onChange={(n) => setConnection({ ...connection, database: n.target.value })}
            type='text'
            placeholder='db'
            required
          />
        </Col>
      </Row>
      <Row className='mb-4'>
        <Col className='pr-1'>
          <Form.Label>Username *</Form.Label>
          <Form.Control
            size='sm'
            type='text'
            value={connection.user}
            onChange={(n) => setConnection({ ...connection, user: n.target.value})}
            placeholder='user'
            required
            autoComplete='new-password'
          />
        </Col>
        <Col className='pl-1'>
          <Form.Label>Password{id ? '' : ' *'}</Form.Label>
          <Form.Control
            size='sm'
            type='password'
            value={connection.password ?? ''}
            placeholder={id ? 'Leave blank to keep current; enter new password to change' : 'Password'}
            onChange={(n) => setConnection({ ...connection, password: n.target.value })}
            required={!id}
            autoComplete={id ? 'off' : 'new-password'}
          />
        </Col>
      </Row>
      <Row className='mb-3'>
        <Col>
          <Form.Label>Does this Mongo cluster utilize VPC peering?</Form.Label>
          <Form.Control
            size='sm'
            as='select'
            value={connection.peering}
            onChange={(n) => setConnection({ ...connection, peering: n.target.value })}
          >
            <option value={false}>No</option>
            <option value={true}>Yes</option>
          </Form.Control>
          <Form.Text>
            Select "yes" if this MongoDB connection utilizes a VPC peering connection.
          </Form.Text>
        </Col>
      </Row>
      {/* <Row className='mb-3'>
        <Col>
          <CronJobEditor 
            scheduleExpression={connection.scheduleExpression}
            scheduleRules={connection.scheduleRules}
            setScheduleData={(v) => setConnection({ ...connection, scheduleExpression: v.scheduleExpression, scheduleRules: v.scheduleRules })}
          />
        </Col>
      </Row> */}
    </div>
  )
}

export default MongoSourceEditor;